import React, { Component } from "react"
import GenericDecoder from "components/Decoders/GenericDecoder";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

class TermCapDecoder extends Component {
  render() {
    return <GenericDecoder location={this.props.location} />
  }
}

TermCapDecoder.propTypes = {
  location: PropTypes.object.isRequired,
}

export default withTranslation()(TermCapDecoder);
